<template>
  <v-footer theme="dark">
    <v-card class="flex" flat tile>
      <v-card-title class="grey darken-3">
        <v-row justify="space-around" align="center">
          <v-col cols="12">
            <img src="@/assets/logo.png" alt="caos suits logo" />
          </v-col>
          <v-col>
            <div class="d-flex flex-column my-3">
              <v-btn to="/suits" variant="text">Custom Suits</v-btn>
              <v-btn to="/about" variant="text">About</v-btn>
              <v-btn to="/contact" variant="text">Contact</v-btn>
            </div>
          </v-col>
          <v-col>
            <div class="d-flex flex-column">
              <v-btn
                href="https://www.facebook.com/heath.thomas.501?fref=nf&__tn__=%2Cdm-R-R&eid=ARC5butTMnpAPjBwHQCn71Z3qA0qFZ_pPKbtQSVDDHWvIGyovAUYYwhlSES22euj1cTs1pLvlTECrE9a"
                rel="noopener noreferrer"
                target="_blank"
                variant="text"
              >
                Facebook
              </v-btn>
              <v-btn
                href="https://www.instagram.com/caossuits/"
                rel="noopener noreferrer"
                target="_blank"
                variant="text"
              >
                Instagram
              </v-btn>
              <v-btn @click="mail" variant="text">caossuits@caossuits.com.au</v-btn>
            </div>
          </v-col>
        </v-row>
      </v-card-title>
    </v-card>
  </v-footer>
</template>

<script>
  export default {
    methods: {
      mail() {
        location.href='mailto:"caossuits@caossuits.com.au"'
      }
    }
  }
</script>

<style scoped>
img {
  max-width: 150px;
}
i {
  font-size: 2rem;
}
</style>
